module.exports = __webpack_public_path__ + "img/presente.b90b4abf.svg";